export default "src/content/themes/association-wordpress-theme/img/9da804f510e85f62ed2368757e47b34e.jpg";